module.exports = __webpack_public_path__ + "static/images/invite-user-phones.705d60e68187bd1a2c9e365dfc1275c7.svg";